import { Divider } from "../divider";

export function DataGridDivider() {
	return <Divider variant="data-grid-divider" />;
}
